<template>
  <div class="empty">
    <img :style="'margin-top:'+mTop+'px'" src="@assets/img/common/empty.svg" alt="empty" class="icon">
    <p class="msg">
      {{msg}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'empty',
  props: {
    msg: {
      type: String,
      required: true
    },
    mTop: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

  .empty {
    width: 100%;
    height: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
      width: auto;
      height: 60px;
      margin-bottom: 18px;
    }
    .msg {
      height: 22px;
      width: 60%;
      text-align: center;
      line-height: 22px;
      font-size: 16px;
      color: @dateColor;
    }
  }
</style>
